<p-splitbutton
  size="small"
  label="Eksportuj"
  icon="pi pi-download"
  [model]="actions"
  styleClass="p-button-primary"
/>
